const React = require('react');

const Container = require('../common/Container.jsx');
const Kit = require('../utility/Kit.jsx');
const Name = require('../utility/Name.jsx');
const _TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

// #region V1

function Columns(props) {
    const config = props.config || {};
    let blockProps = {};
    let headerProps = {};
    if (config.Config) {
        if (config.Config.Block) {
            blockProps = config.Config.Block;
        }
        if (config.Config.Header) {
            headerProps = config.Config.Header;
        }
    }
    let dataType;
    if (props.builder) {
        dataType = props.dataType || 'layout';
    }
    let hasHeaderData = false;
    const headers = [];
    const columns = props.columns || config.Columns || [];
    const columnsData = columns.map(function (column, i) {
        let componentData;
        if (props.componentData) {
            if (i < props.componentData.length) {
                componentData = props.componentData[i];
            } else if (props.componentData.length > 0) {
                componentData = props.componentData[0];
            }
            if (!componentData) {
                return;
            }
        }
        let columnDataVisible = false;
        const columnData = [];
        if (column) {
            column.forEach(function (d) {
                const Component = props.onComponent(d, componentData, props.typeHandler);
                if (!Component) {
                    return;
                }
                columnData.push(Component);

                if (props.forceVisibility || Utilities.Config.getVisibility(Component.props.config)) {
                    columnDataVisible = true;
                }
            });
        }
        const prefix = `col${i + 1}_`;
        if (!props.builder && !columnDataVisible && blockProps[`${prefix}collapseIfEmpty`]) {
            return;
        }
        const header = headerProps[`${prefix}textLabel`] || '';
        const style = Utilities.Config.getStyle(
            props.data,
            headerProps,
            '',
            {
                backgroundColor: headerProps.backgroundColor,
                marginBottom: undefined,
                paddingBottom: headerProps.paddingBottom,
                paddingLeft: headerProps[`${prefix}paddingLeft`],
                paddingRight: headerProps[`${prefix}paddingRight`],
                paddingTop: headerProps.paddingTop,
                textAlign: headerProps[`${prefix}textAlign`],
                verticalAlign: headerProps[`${prefix}verticalAlign`],
                width: blockProps[`${prefix}width`]
            },
            prefix
        );
        if (!Utilities.isNullOrWhitespace(header)) {
            hasHeaderData = true;
            if (!style.fontSize) {
                style.fontSize = '16px';
            }
        }
        headers.push(<td key={prefix} className="layout-header" style={style}>{header}</td>);

        let columnProps = {};
        if (props.onColumnProps) {
            columnProps = props.onColumnProps(i) || {};
        }
        return (
            <Column
                key={i}
                blockProps={blockProps}
                builder={props.builder}
                columnData={columnData}
                columnDataVisible={columnDataVisible}
                dataType={dataType}
                dragging={props.dragging}
                id={`${config.Id}-child-${i}`}
                prefix={prefix}
                {...columnProps} />
        );
    });
    let hasColumnData = false;
    for (let i = 0; i < columns.length; i++) {
        if (columns[i].length > 0) {
            hasColumnData = true;
            break;
        }
    }
    let minHeight, rowStyle;
    if (config.Config && config.Config.Style && config.Config.Style.minHeight) {
        minHeight = config.Config.Style.minHeight;
        rowStyle = { height: minHeight };
    }
    const styleLayoutSpacer = { height: props.builder ? '0.01px' : '0px', maxHeight: props.builder ? '0.01px' : '0px' };
    if (!Utilities.isNullOrWhitespace(blockProps.borderTop)) {
        styleLayoutSpacer.borderBottom = blockProps.borderTop;
    }
    if (!Utilities.isNullOrWhitespace(blockProps.borderTopSpacing)) {
        styleLayoutSpacer.paddingBottom = blockProps.borderTopSpacing;
    }
    if (!Utilities.isNullOrWhitespace(headerProps.lineSpacing)) {
        styleLayoutSpacer.paddingTop = headerProps.lineSpacing;
    }
    let borderStyle;
    if (!Utilities.isNullOrWhitespace(blockProps.borderBottom)) {
        borderStyle = { borderBottom: blockProps.borderBottom };
    }
    if (!Utilities.isNullOrWhitespace(blockProps.borderBottomSpacing)) {
        borderStyle = borderStyle || {};
        borderStyle.paddingTop = blockProps.borderBottomSpacing;
    }
    let borderBottom;
    if (borderStyle) {
        borderBottom = <tr><td colSpan={columnsData.length} style={borderStyle} /></tr>;
    }
    let className = props.className;
    if (props.avoidPageBreaks) {
        if (!className) {
            className = 'pageBreakInsideAvoid';
        } else {
            className += ' pageBreakInsideAvoid';
        }
    }
    return (
        <React.Fragment>
            <Container
                builder={props.builder}
                className={className}
                colSpan={columns.length}
                config={props.config}
                dataType={dataType}
                style={props.style}
                onClick={props.onClick}
                onDragStart={props.onDragStart}>
                {props.children}
                {
                    props.renderHeader != false &&
                    <React.Fragment>
                        {
                            hasHeaderData &&
                            <tr>
                                {headers}
                            </tr>
                        }
                        <tr>
                            {
                                columnsData.map((d, i) => <td key={i} className="layout-spacer" style={styleLayoutSpacer} />)
                            }
                        </tr>
                    </React.Fragment>
                }
                <tr style={rowStyle}>
                    {columnsData}
                    {
                        props.builder &&
                        !hasColumnData &&
                        <td className="layout-placeholder" style={{ maxWidth: '0px', width: '0px' }}>
                            <div style={{ borderBottom: 'none', borderTop: 'none', marginLeft: '-1px', maxWidth: '0px', minHeight: minHeight }}>
                                {Utilities.Builder.emptyBlockPlaceholder()}
                            </div>
                        </td>
                    }
                </tr>
                {borderBottom}
            </Container>
            {
                props.builder == true &&
                props.dragging &&
                <div id={`${config.Id}-hidden`} className="hidden draggable" />
            }
        </React.Fragment>
    );
}

function Column(props) {
    const blockProps = props.blockProps || {};
    const style = { position: 'relative' };
    let temp = blockProps[`${props.prefix}minWidth`];
    if (!Utilities.isNullOrWhitespace(temp)) {
        style.minWidth = temp;
    }
    temp = blockProps[`${props.prefix}paddingBottom`];
    if (!Utilities.isNullOrWhitespace(temp)) {
        style.paddingBottom = temp;
    }
    temp = blockProps[`${props.prefix}paddingLeft`];
    if (!Utilities.isNullOrWhitespace(temp)) {
        style.paddingLeft = temp;
    }
    temp = blockProps[`${props.prefix}paddingRight`];
    if (!Utilities.isNullOrWhitespace(temp)) {
        style.paddingRight = temp;
    }
    temp = blockProps[`${props.prefix}paddingTop`];
    if (!Utilities.isNullOrWhitespace(temp)) {
        style.paddingTop = temp;
    }
    if (!Utilities.isNullOrWhitespace(blockProps.verticalAlign)) {
        style.verticalAlign = blockProps.verticalAlign;
    }
    temp = blockProps[`${props.prefix}verticalAlign`];
    if (!Utilities.isNullOrWhitespace(temp)) {
        style.verticalAlign = temp;
    }
    if (props.builder && props.columnData.length == 0) {
        style.verticalAlign = 'top';
    }

    let width = blockProps[`${props.prefix}width`];
    if (width) {
        // Legacy support
        let temp = width.replace(/\D/g, '');
        if (width.length == temp.length) {
            width = `${temp}%`;
        }
    }
    if (!props.builder && !props.columnDataVisible && blockProps[`${props.prefix}collapseIfEmpty`]) {
        style.minWidth = 0;
        style.paddingBottom = 0;
        style.paddingLeft = 0;
        style.paddingRight = 0;
        style.paddingTop = 0;
        width = 0;
    }
    let className;
    switch (props.dataType) {
        case 'container':
            className = 'container-cont';
            if (props.disabled) {
                className += ' container-disabled';
            }
            break;
        default:
            className = 'layout-cont';
            if (props.disabled) {
                className += ' layout-disabled';
            }
            break;
    }
    return (
        <td
            id={props.id}
            className={className}
            data-type={props.dataType}
            style={style}
            width={width}>
            {
                props.builder == true &&
                props.disabled != true &&
                props.dragging &&
                <div id={`${props.id}-hidden`} className="hidden draggable" />
            }
            {props.columnData}
        </td>
    );
}

const TypeConfig = {
    options: {
        column: function (column, props, width, minWidth, verticalAlign, collapseIfEmpty) {
            if (!column || !column.number) {
                return [
                    _TypeConfig.options.firstPageOnly(),
                    ..._TypeConfig.options.border()
                ];
            }
            const prefix = `col${column.number}`;
            const _props = props || {};
            let _minWidth;
            if (minWidth) {
                _minWidth = {
                    display: 'Minimum Width',
                    name: `${prefix}_minWidth`,
                    type: 'text',
                    ..._props,
                    ...minWidth
                };
            } else {
                _minWidth = { type: 'spacer' };
            }
            const _width = width || {};
            const options = [
                { display: column.display || `Column ${column.number} Properties`, id: `${prefix}Props`, type: 'header' },
                {
                    display: 'Width',
                    name: `${prefix}_width`,
                    type: 'text',
                    ..._props,
                    ..._width
                },
                _minWidth,
                {
                    display: 'Padding Top',
                    name: `${prefix}_paddingTop`,
                    type: 'text',
                    ..._props
                },
                {
                    display: 'Padding Bottom',
                    name: `${prefix}_paddingBottom`,
                    type: 'text',
                    ..._props
                },
                {
                    display: 'Padding Left',
                    name: `${prefix}_paddingLeft`,
                    type: 'text',
                    ..._props
                },
                {
                    display: 'Padding Right',
                    name: `${prefix}_paddingRight`,
                    type: 'text',
                    ..._props
                }
            ];
            if (verticalAlign) {
                options.push({
                    display: 'Vertical Alignment',
                    name: `${prefix}_verticalAlign`,
                    options: [
                        { display: 'Top', value: 'top' },
                        { display: 'Middle', value: 'middle' },
                        { display: 'Bottom', value: 'bottom' }
                    ],
                    type: 'dropdown',
                    value: 'top',
                    ..._props,
                    ...verticalAlign
                });
            }
            if (collapseIfEmpty) {
                options.push({
                    display: 'Collapse If Empty',
                    name: `${prefix}_collapseIfEmpty`,
                    type: 'checkbox',
                    value: false,
                    ...collapseIfEmpty
                });
            }
            return options;
        },
        header: function (column) {
            if (!column || !column.number) {
                return [
                    {
                        display: 'Only Show Header On First Item',
                        fullWidth: true,
                        name: 'renderHeaderOnlyFirst',
                        type: 'checkbox',
                        value: false,
                        visible: function (config, parentConfig) {
                            return parentConfig && parentConfig.Type == 'itemContainer';
                        }
                    },
                    {
                        display: 'Padding Top',
                        name: 'paddingTop',
                        type: 'text'
                    },
                    {
                        display: 'Padding Bottom',
                        name: 'paddingBottom',
                        type: 'text'
                    },
                    {
                        display: 'Background Color',
                        name: 'backgroundColor',
                        type: 'text'
                    },
                    {
                        display: 'Line Spacing',
                        name: 'lineSpacing',
                        type: 'text'
                    }
                ];
            }
            const prefix = `col${column.number}`;
            return [
                { display: column.display || `Column ${column.number} Header Properties`, id: `${prefix}HeaderProps`, type: 'header' },
                {
                    display: 'Display Text',
                    name: `${prefix}_textLabel`,
                    type: 'text'
                },
                { type: 'spacer' },
                {
                    display: 'Collateral Style',
                    name: `${prefix}_style`,
                    options: [
                        { display: 'Header', value: 'header' },
                        { display: 'Body', value: 'body' }
                    ],
                    type: 'dropdown',
                    value: 'body'
                },
                {
                    display: 'Override Text Color',
                    name: `${prefix}_color`,
                    type: 'text'
                },
                {
                    display: 'Text Size',
                    name: `${prefix}_fontSize`,
                    type: 'text'
                },
                {
                    display: 'Line Height',
                    name: `${prefix}_lineHeight`,
                    type: 'text'
                },
                {
                    display: 'Font Weight',
                    name: `${prefix}_fontWeight`,
                    type: 'text'
                },
                {
                    display: 'Font Style',
                    name: `${prefix}_fontStyle`,
                    options: [
                        { display: 'Normal', value: 'normal' },
                        { display: 'Italic', value: 'italic' }
                    ],
                    type: 'dropdown',
                    value: 'normal'
                },
                { type: 'spacer' },
                { type: 'spacer' },
                {
                    display: 'Vertical Alignment',
                    name: `${prefix}_verticalAlign`,
                    options: [
                        { display: 'Top', value: 'top' },
                        { display: 'Middle', value: 'middle' },
                        { display: 'Bottom', value: 'bottom' }
                    ],
                    type: 'dropdown',
                    value: 'middle'
                },
                {
                    display: 'Text Alignment',
                    name: `${prefix}_textAlign`,
                    options: [
                        { display: 'Left', value: 'left' },
                        { display: 'Center', value: 'center' },
                        { display: 'Right', value: 'right' }
                    ],
                    type: 'dropdown',
                    value: 'left'
                },
                {
                    display: 'Padding Left',
                    name: `${prefix}_paddingLeft`,
                    type: 'text'
                },
                {
                    display: 'Padding Right',
                    name: `${prefix}_paddingRight`,
                    type: 'text'
                }
            ];
        }
    },
    panel: {
        style: function () { return _TypeConfig.panel.layoutStyle({}, undefined, {}); }
    }
};

// #endregion V1

// #region V2

const ColumnUtilities = {
    updateStyleForDivider: (style, dividers, index, count) => {
        let dividerData = dividers[index];
        if (dividerData && dividerData.width && !Utilities.isNullOrWhitespace(dividerData.width.value)) {
            const value = parseFloat(dividerData.width.value) / 2.0;
            if (!isNaN(value)) {
                style.borderLeftColor = dividerData.color;
                style.borderLeftStyle = 'solid';
                style.borderLeftWidth = `${value}${dividerData.width.unit}`;
            }
        }
        if (index + 1 < count) {
            dividerData = dividers[index + 1];
            if (dividerData && dividerData.width && !Utilities.isNullOrWhitespace(dividerData.width.value)) {
                const value = parseFloat(dividerData.width.value) / 2.0;
                if (!isNaN(value)) {
                    style.borderRightColor = dividerData.color;
                    style.borderRightStyle = 'solid';
                    style.borderRightWidth = `${value}${dividerData.width.unit}`;
                }
            }
        }
    }
}

function ColumnsV2(props) {
    const config = props.config || {};
    const blockProps = config.config && config.config.Block || {};
    const dataType = 'layout';

    const columnProps = {};
    const columnDividers = {};
    const headerDividers = {};
    let width;
    const blockStyle = Utilities.Config.getStyleV2(blockProps, props.style, (propName, propValue, _style) => {
        const index = propName.indexOf('-');
        if (index < 0) {
            switch (propName) {
                case 'columnCount':
                    return true;
            }
            // Let the utility method process the property as normal
            return false;
        }
        const _propName = propName.substring(0, index);
        const columnId = propName.substring(index + 1);
        const dividerId = columnId.replace('col', '') - 1;
        if (!columnDividers[dividerId]) {
            columnDividers[dividerId] = {};
        }
        if (!headerDividers[dividerId]) {
            headerDividers[dividerId] = {};
        }
        const colProps = columnProps[columnId] || {};
        const colStyle = colProps.style || {};
        const headerStyle = colProps.headerStyle || {};
        switch (_propName) {
            case 'alignment':
                Utilities.Config.updateStyleAlignment(propValue, colStyle);
                break;
            case 'alignmentHeader':
                Utilities.Config.updateStyleAlignment(propValue, headerStyle);
                break;
            case 'backgroundColorHeader':
                headerStyle.backgroundColor = propValue;
                break;
            case 'collapseIfEmpty':
            case 'designHeader':
                colProps[_propName] = propValue;
                break;
            case 'dividerColor':
                columnDividers[dividerId].color = propValue;
                break;
            case 'dividerColorHeader':
                headerDividers[dividerId].color = propValue;
                break;
            case 'dividerWidth':
                if (propValue != undefined && !Utilities.isNullOrWhitespace(propValue.value)) {
                    columnDividers[dividerId].width = propValue;
                }
                break;
            case 'dividerWidthHeader':
                if (propValue != undefined && !Utilities.isNullOrWhitespace(propValue.value)) {
                    headerDividers[dividerId].width = propValue;
                }
                break;
            case 'paddingBottomHeader':
            case 'paddingLeftHeader':
            case 'paddingRightHeader':
            case 'paddingTopHeader':
                let value = undefined;
                if (propValue != undefined && !Utilities.isNullOrWhitespace(propValue.value)) {
                    value = `${propValue.value}${propValue.unit}`;
                }
                headerStyle[_propName.replace('Header', '')] = value;
                break;
            case 'width':
                if (propValue != undefined && !Utilities.isNullOrWhitespace(propValue.value)) {
                    width = propValue.value;
                    if (propValue.unit == '%') {
                        width = `${width}%`;
                    }
                    colProps.width = width;
                } else {
                    colProps.width = undefined;
                }
            // Intentional fallthrough
            default:
                let _propValue;
                if (propValue != undefined && propValue.unit) {
                    _propValue = !Utilities.isNullOrWhitespace(propValue.value) ? `${propValue.value}${propValue.unit}` : undefined;
                } else if (!Utilities.isNullOrWhitespace(propValue)) {
                    _propValue = propValue;
                }
                // Set the property value in the specific column's style
                colStyle[_propName] = _propValue;
                break;
        }
        colProps.style = colStyle;
        colProps.headerStyle = headerStyle;
        columnProps[columnId] = colProps;
        return true;
    });
    let hasHeaderData = false;
    const headers = [];
    const columns = props.columns || config.blocks || [];
    const columnsData = columns.map((column, i) => {
        let columnDataVisible = false;
        const columnData = [];
        if (column) {
            column.forEach((d) => {
                const Component = props.onComponent(d, undefined, props.typeHandler);
                if (!Component) {
                    return;
                }
                columnData.push(Component);

                if (props.forceVisibility) {
                    columnDataVisible = true;
                } else if (props.visibility && d.config && d.config.Block && d.config.Block.design) {
                    let _content = Utilities.getHTMLContent(d.config.Block.design);
                    for (let id in props.visibility) {
                        if (props.visibility[id]) {
                            continue;
                        }
                        const searchString = `{${id}`;
                        const startIndex = _content.indexOf(searchString);
                        if (startIndex < 0) {
                            continue;
                        }
                        const endIndex = _content.indexOf('}', startIndex);
                        if (endIndex < 0) {
                            continue;
                        }
                        _content = _content.substring(0, startIndex) + _content.substring(endIndex + 1);
                    }
                    if (_content.length > 0) {
                        columnDataVisible = true;
                    }
                } else if (Utilities.Config.getVisibility(Component.props.config)) {
                    columnDataVisible = true;
                }
            });
        }
        const columnId = `col${i + 1}`;
        const _columnProps = columnProps[columnId] || {};
        if (!props.builder && !columnDataVisible && _columnProps.collapseIfEmpty) {
            return;
        }
        if (!Utilities.isHTMLContentEmpty(_columnProps.designHeader)) {
            hasHeaderData = true;
        }
        const headerStyle = _columnProps.headerStyle || {};
        ColumnUtilities.updateStyleForDivider(headerStyle, headerDividers, i, blockProps.columnCount);

        let separator;
        if (props.builder) {
            headerStyle.position = 'relative';
            if (i < blockProps.columnCount - 1) {
                separator = <div key={`sep-${columnId}`} className="drag-outline-layout-child" style={{ right: headerStyle.borderRightWidth ? `-${headerStyle.borderRightWidth}` : 0, zIndex: 1 }} />
            }
        }
        if (blockStyle) {
            if (i == 0) {
                headerStyle.borderLeftColor = blockStyle.borderLeftColorHeader;
                headerStyle.borderLeftStyle = blockStyle.borderLeftStyleHeader;
                headerStyle.borderLeftWidth = blockStyle.borderLeftWidthHeader;
            } else if (i == blockProps.columnCount - 1) {
                headerStyle.borderRightColor = blockStyle.borderRightColorHeader;
                headerStyle.borderRightStyle = blockStyle.borderRightStyleHeader;
                headerStyle.borderRightWidth = blockStyle.borderRightWidthHeader;
            }
        }
        headers.push(
            <td key={columnId} className="layout-header" style={headerStyle}>
                <div dangerouslySetInnerHTML={{ __html: Kit.updateDesign(_columnProps.designHeader, props.kit) }} />
                {separator}
            </td>
        );
        // let columnProps = {};
        // if (props.onColumnProps) {
        //     columnProps = props.onColumnProps(i) || {};
        // }
        return (
            <ColumnV2
                key={i}
                blockStyle={blockStyle}
                blockType={props.blockType}
                builder={props.builder}
                columnCount={blockProps.columnCount}
                columnData={columnData}
                columnDataVisible={columnDataVisible}
                dataType={dataType}
                dividers={columnDividers}
                dragging={props.dragging}
                id={`${config.id}-child-${i}`}
                index={i}
                onDragEnter={props.onDragEnter}
                {..._columnProps} />
        );
    });
    // let hasColumnData = false;
    // for (let i = 0; i < columns.length; i++) {
    //     if (columns[i].length > 0) {
    //         hasColumnData = true;
    //         break;
    //     }
    // }
    let minHeight, rowStyle;
    if (config.config && config.config.Style && config.config.Style.minHeight) {
        minHeight = `${config.config.Style.minHeight.value}${config.config.Style.minHeight.unit}`;
        rowStyle = { height: minHeight };
    }
    const styleLayoutSpacer = { height: props.builder ? '0.01px' : '0px', maxHeight: props.builder ? '0.01px' : '0px' };
    if (!Utilities.isNullOrWhitespace(blockStyle.borderTopWidth)) {
        styleLayoutSpacer.borderBottomColor = blockStyle.borderTopColor;
        styleLayoutSpacer.borderBottomStyle = blockStyle.borderTopStyle;
        styleLayoutSpacer.borderBottomWidth = blockStyle.borderTopWidth;
    }
    if (!Utilities.isNullOrWhitespace(blockStyle.spacing)) {
        styleLayoutSpacer.paddingTop = blockStyle.spacing;
    }
    let borderBottom;
    if (!Utilities.isNullOrWhitespace(blockStyle.borderBottomWidth)) {
        borderBottom = <tr><td colSpan={columnsData.length} style={{ borderBottomColor: blockStyle.borderBottomColor, borderBottomStyle: blockStyle.borderBottomStyle, borderBottomWidth: blockStyle.borderBottomWidth }} /></tr>
    }
    let className = 'layout';
    if (props.className) {
        className += ` ${props.className}`;
    }
    if (props.avoidPageBreaks) {
        className += ' pageBreakInsideAvoid';
    }
    let content = (
        <>
            <Container
                bodyProps={props.builder ? { style: { position: 'relative' } } : undefined}
                builder={props.builder}
                className={className}
                colSpan={columns.length}
                config={props.config}
                dataType={dataType}
                onClick={props.onClick}
                onDragStart={props.onDragStart}>
                {props.children}
                {
                    props.builder &&
                    <tr className="builder__controls">
                        <td className="builder__controls--label" colSpan={columns.length}>
                            <div>{props.blockType ? 'CONTAINER' : 'COLUMNS'}</div>
                        </td>
                    </tr>
                }
                {
                    props.renderHeader != false &&
                    hasHeaderData &&
                    <>
                        {
                            !Utilities.isNullOrWhitespace(blockStyle.borderTopWidthHeader) &&
                            <tr>
                                <td colSpan={columnsData.length} style={{ borderBottomColor: blockStyle.borderTopColorHeader, borderBottomStyle: blockStyle.borderTopStyleHeader, borderBottomWidth: blockStyle.borderTopWidthHeader }} />
                            </tr>
                        }
                        <tr>
                            {headers}
                        </tr>
                        {
                            !Utilities.isNullOrWhitespace(blockStyle.borderBottomWidthHeader) &&
                            <tr>
                                <td colSpan={columnsData.length} style={{ borderBottomColor: blockStyle.borderBottomColorHeader, borderBottomStyle: blockStyle.borderBottomStyleHeader, borderBottomWidth: blockStyle.borderBottomWidthHeader }} />
                            </tr>
                        }
                        <tr>
                            {
                                columnsData.map((_, i) => <td key={i} className="layout-spacer" style={styleLayoutSpacer} />)
                            }
                        </tr>
                    </>
                }
                {
                    !Utilities.isNullOrWhitespace(blockStyle.borderTopWidth) &&
                    <tr>
                        <td colSpan={columnsData.length} style={{ borderBottomColor: blockStyle.borderBottomColor, borderBottomStyle: blockStyle.borderBottomStyle, borderBottomWidth: blockStyle.borderBottomWidth }} />
                    </tr>
                }
                <tr style={rowStyle}>
                    {columnsData}
                    {
                        props.builder &&
                        <td><div className="drag-outline drag-outline-layout drag-outline-layout-parent" /></td>
                    }
                </tr>
                {
                    !Utilities.isNullOrWhitespace(blockStyle.borderBottomWidth) &&
                    <tr>
                        <td colSpan={columnsData.length} style={{ borderBottomColor: blockStyle.borderBottomColor, borderBottomStyle: blockStyle.borderBottomStyle, borderBottomWidth: blockStyle.borderBottomWidth }} />
                    </tr>
                }
            </Container>
            {
                props.builder == true &&
                props.dragging &&
                <div id={`${config.id}-hidden`}
                    className="hidden draggable"
                    data-type={dataType}
                    onDragEnter={props.onDragEnter} />
            }
        </>
    );
    // if (props.builder) {
    //     content = <div style={{ position: 'relative' }}>{content}</div>
    // }
    return content;
}

function ColumnV2(props) {
    let width = props.width;
    const style = props.style ? { ...props.style } : {};
    ColumnUtilities.updateStyleForDivider(style, props.dividers, props.index, props.columnCount);
    const isLast = props.index == props.columnCount - 1;
    if (props.blockStyle) {
        if (props.index == 0) {
            style.borderLeftColor = props.blockStyle.borderLeftColor;
            style.borderLeftStyle = props.blockStyle.borderLeftStyle;
            style.borderLeftWidth = props.blockStyle.borderLeftWidth;
        } else if (isLast) {
            style.borderRightColor = props.blockStyle.borderRightColor;
            style.borderRightStyle = props.blockStyle.borderRightStyle;
            style.borderRightWidth = props.blockStyle.borderRightWidth;
        }
    }
    const hasColumnData = props.columnData.length > 0;
    let className = 'layout-cont';
    if (props.builder) {
        className += ' layout-child';
        style.position = 'relative';

        if (!hasColumnData) {
            style.verticalAlign = 'top';
        }
    } else if (!props.columnDataVisible && props.collapseIfEmpty) {
        style.minWidth = 0;
        style.paddingBottom = 0;
        style.paddingLeft = 0;
        style.paddingRight = 0;
        style.paddingTop = 0;
        style.width = 0;
        width = 0;
    }
    return (
        <td
            id={props.id}
            className={className}
            data-block-type={props.blockType || Name.Block.Columns}
            data-type={props.dataType}
            style={style}
            width={width}>

            {
                props.builder &&
                <>
                    {
                        props.parentStyle &&
                        props.parentStyle.paddingTop &&
                        <div className="drag-outline-layout-child drag-outline-layout-child-top" />
                    }
                    {
                        !isLast &&
                        <div className="drag-outline-layout-child" style={{ right: style.borderRightWidth ? `-${style.borderRightWidth}` : 0, zIndex: 1 }} />
                    }
                    {
                        props.dragging &&
                        <div id={`${props.id}-hidden-first`}
                            className="hidden hidden-child-first draggable"
                            data-type={props.dataType}
                            onDragEnter={props.onDragEnter} />
                    }
                </>
            }
            {props.columnData}
            {
                props.builder &&
                <>
                    {
                        !hasColumnData &&
                        !props.dragging &&
                        Utilities.Builder.emptyBlockPlaceholder()
                    }
                    {
                        props.dragging &&
                        <div id={`${props.id}-hidden`}
                            className="hidden hidden-child-last draggable"
                            data-type={props.dataType}
                            style={!hasColumnData && props.dragging ? { marginTop: '10px' } : undefined}
                            onDragEnter={props.onDragEnter} />
                    }
                    {
                        props.parentStyle &&
                        props.parentStyle.paddingBottom &&
                        <div className="drag-outline-layout-child drag-outline-layout-child-bottom" />
                    }
                </>
            }
        </td>
    );
}

const TypeConfigV2 = {
    options: {
        column: (column, visible) => {
            const group = `col${column}`;
            const relatedProperty = column > 1 ? 'columnCount' : undefined;
            const options = [
                {
                    display: `Column ${column}`,
                    group,
                    id: `${group}Props`,
                    type: 'tab',
                    visible
                },
                {
                    default: {
                        '2': undefined,
                        '3': undefined,
                        '4': undefined,
                        '5': undefined,
                        '6': undefined
                    },
                    display: 'Collapse If Empty',
                    fullWidth: true,
                    group,
                    name: `collapseIfEmpty-${group}`,
                    relatedProperty,
                    type: 'checkbox',
                    value: false,
                    visible
                },
                {
                    display: 'Header Configuration',
                    group,
                    id: `headerProps-${group}`,
                    type: 'header',
                    visible
                },
                {
                    default: {
                        '2': column > 1 ? undefined : 'tl',
                        '3': column > 2 ? undefined : 'tl',
                        '4': column > 3 ? undefined : 'tl',
                        '5': column > 4 ? undefined : 'tl',
                        '6': column > 5 ? undefined : 'tl'
                    },
                    display: 'Align Header',
                    group,
                    name: `alignmentHeader-${group}`,
                    relatedProperty,
                    type: 'alignment',
                    value: 'tl',
                    visible
                },
                {
                    default: {
                        '2': undefined,
                        '3': undefined,
                        '4': undefined,
                        '5': undefined,
                        '6': undefined
                    },
                    display: 'Background Color',
                    group,
                    name: `backgroundColorHeader-${group}`,
                    relatedProperty,
                    type: 'color',
                    visible
                },
                {
                    default: {
                        '2': undefined,
                        '3': undefined,
                        '4': undefined,
                        '5': undefined,
                        '6': undefined
                    },
                    display: 'Header Design',
                    fullWidth: true,
                    group,
                    name: `designHeader-${group}`,
                    relatedProperty,
                    type: 'rich-text-collateral-short',
                    visible
                },
                {
                    default: {
                        '2': undefined,
                        '3': undefined,
                        '4': undefined,
                        '5': undefined,
                        '6': undefined
                    },
                    disabled: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
                    display: 'Header Padding',
                    group,
                    name: `paddingMarginHeader-${group}`,
                    nameSuffix: `Header-${group}`,
                    options: _TypeConfig.dropdown.measurement(),
                    relatedProperty,
                    type: 'paddingMargin',
                    visible
                }
            ];
            if (column > 1) {
                options.push(
                    {
                        default: {
                            '2': undefined,
                            '3': undefined,
                            '4': undefined,
                            '5': undefined,
                            '6': undefined
                        },
                        display: 'Header Divider Width',
                        group,
                        name: `dividerWidthHeader-${group}`,
                        options: _TypeConfig.dropdown.measurement(),
                        relatedProperty: 'columnCount',
                        type: 'measurement',
                        visible
                    },
                    {
                        default: {
                            '2': undefined,
                            '3': undefined,
                            '4': undefined,
                            '5': undefined,
                            '6': undefined
                        },
                        display: 'Header Divider Color',
                        group,
                        name: `dividerColorHeader-${group}`,
                        relatedProperty: 'columnCount',
                        type: 'color',
                        visible
                    }
                )
            }
            options.push(
                {
                    display: 'Content Configuration',
                    expanded: true,
                    group,
                    id: `contentProps-${group}`,
                    type: 'header',
                    visible
                },
                {
                    default: {
                        '2': column > 1 ? undefined : 'tl',
                        '3': column > 2 ? undefined : 'tl',
                        '4': column > 3 ? undefined : 'tl',
                        '5': column > 4 ? undefined : 'tl',
                        '6': column > 5 ? undefined : 'tl'
                    },
                    display: 'Align Content',
                    group,
                    name: `alignment-${group}`,
                    type: 'alignment',
                    relatedProperty,
                    value: 'tl',
                    visible
                },
                {
                    default: {
                        '2': undefined,
                        '3': undefined,
                        '4': undefined,
                        '5': undefined,
                        '6': undefined
                    },
                    display: 'Background Color',
                    group,
                    name: `backgroundColor-${group}`,
                    relatedProperty,
                    type: 'color',
                    visible
                },
                {
                    default: {
                        '2': undefined,
                        '3': undefined,
                        '4': undefined,
                        '5': undefined,
                        '6': undefined
                    },
                    disabled: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
                    display: 'Padding',
                    group,
                    name: `paddingMargin-${group}`,
                    nameSuffix: `-${group}`,
                    options: _TypeConfig.dropdown.measurement(),
                    relatedProperty,
                    type: 'paddingMargin',
                    visible
                },
                {
                    fullWidth: true,
                    group,
                    type: 'spacer-short',
                    visible
                },
                {
                    default: {
                        '2': undefined,
                        '3': undefined,
                        '4': undefined,
                        '5': undefined,
                        '6': undefined
                    },
                    display: 'Minimum Width',
                    fullWidth: true,
                    group,
                    name: `minWidth-${group}`,
                    options: _TypeConfig.dropdown.measurement(true),
                    relatedProperty,
                    type: 'measurement-slider',
                    visible
                },
                {
                    default: {
                        '2': { unit: '%', value: '50' },
                        '3': { unit: '%', value: '33.33' },
                        '4': { unit: '%', value: '25' },
                        '5': { unit: '%', value: '20' },
                        '6': { unit: '%', value: '16.67' }
                    },
                    display: 'Width',
                    fullWidth: true,
                    group,
                    name: `width-${group}`,
                    options: _TypeConfig.dropdown.measurement(true),
                    relatedProperty: 'columnCount',
                    relatedPropertyOverridable: true,
                    type: 'measurement-slider',
                    value: { unit: '%', value: '50' },
                    visible
                }
            );
            if (column > 1) {
                options.push(
                    {
                        default: {
                            '2': undefined,
                            '3': undefined,
                            '4': undefined,
                            '5': undefined,
                            '6': undefined
                        },
                        display: 'Column Divider Width',
                        group,
                        name: `dividerWidth-${group}`,
                        options: _TypeConfig.dropdown.measurement(),
                        relatedProperty: 'columnCount',
                        type: 'measurement',
                        visible
                    },
                    {
                        default: {
                            '2': undefined,
                            '3': undefined,
                            '4': undefined,
                            '5': undefined,
                            '6': undefined
                        },
                        display: 'Column Divider Color',
                        group,
                        name: `dividerColor-${group}`,
                        relatedProperty: 'columnCount',
                        type: 'color',
                        visible
                    }
                )
            }
            return options;
        }
    },
    panel: {
        block: (contentType) => {
            const group = 'block';
            const options = [
                {
                    display: 'Column Count',
                    group,
                    name: 'columnCount',
                    options: [
                        { display: '2', value: '2' },
                        { display: '3', value: '3' },
                        { display: '4', value: '4' },
                        { display: '5', value: '5' },
                        { display: '6', value: '6' }
                    ],
                    relatedProperties: [
                        'alignment-col2',
                        'alignment-col3',
                        'alignment-col4',
                        'alignment-col5',
                        'alignment-col6',
                        'backgroundColor-col2',
                        'backgroundColor-col3',
                        'backgroundColor-col4',
                        'backgroundColor-col5',
                        'backgroundColor-col6',
                        'borderLeftColor-col2',
                        'borderLeftColor-col3',
                        'borderLeftColor-col4',
                        'borderLeftColor-col5',
                        'borderLeftColor-col6',
                        'borderLeftWidth-col2',
                        'borderLeftWidth-col3',
                        'borderLeftWidth-col4',
                        'borderLeftWidth-col5',
                        'borderLeftWidth-col6',
                        'collapseIfEmpty-col2',
                        'collapseIfEmpty-col3',
                        'collapseIfEmpty-col4',
                        'collapseIfEmpty-col5',
                        'collapseIfEmpty-col6',
                        'minWidth-col2',
                        'minWidth-col3',
                        'minWidth-col4',
                        'minWidth-col5',
                        'minWidth-col6',
                        'paddingMargin-col2',
                        'paddingMargin-col3',
                        'paddingMargin-col4',
                        'paddingMargin-col5',
                        'paddingMargin-col6',
                        'width-col1',
                        'width-col2',
                        'width-col3',
                        'width-col4',
                        'width-col5',
                        'width-col6'
                    ],
                    type: 'dropdown',
                    value: '2'
                }
            ];
            switch (contentType) {
                case Name.Content.ArtistBioItem:
                case Name.Content.CertificateItem:
                case Name.Content.ConsignmentLineItem:
                case Name.Content.CreditLineItem:
                case Name.Content.InvoiceLineItem:
                case Name.Content.PaymentLineItem:
                case Name.Content.PricelistInventoryItem:
                case Name.Content.PurchaseOrderLineItem:
                case Name.Content.TearsheetItem:
                    options.push({
                        display: 'Only Show Header On First Item',
                        fullWidth: true,
                        group,
                        name: 'renderHeaderOnlyFirst',
                        type: 'checkbox',
                        value: false
                    })
                    break;
            }
            options.push(
                {
                    display: 'Header Border',
                    group,
                    name: 'borderHeader',
                    nameSuffix: 'Header',
                    options: _TypeConfig.dropdown.measurement(),
                    type: 'border'
                },
                {
                    group,
                    type: 'spacer-short'
                },
                {
                    display: 'Spacing Between Header and Content',
                    fullWidth: true,
                    group,
                    name: 'spacing',
                    options: _TypeConfig.dropdown.measurement(),
                    type: 'measurement-slider'
                },
                {
                    group,
                    type: 'spacer-short'
                },
                {
                    display: 'Content Border',
                    group,
                    name: 'border',
                    options: _TypeConfig.dropdown.measurement(),
                    type: 'border'
                },
                ...TypeConfigV2.options.column(1),
                ...TypeConfigV2.options.column(2, TypeConfigV2.visibility.hasAtLeast2Columns),
                ...TypeConfigV2.options.column(3, TypeConfigV2.visibility.hasAtLeast3Columns),
                ...TypeConfigV2.options.column(4, TypeConfigV2.visibility.hasAtLeast4Columns),
                ...TypeConfigV2.options.column(5, TypeConfigV2.visibility.hasAtLeast5Columns),
                ...TypeConfigV2.options.column(6, TypeConfigV2.visibility.hasAtLeast6Columns)
            );
            return {
                group,
                label: 'Design',
                options
            };
        },
        style: () => _TypeConfig.panel.layoutStyleV2('block', undefined, {}, undefined, {})
        // style: () => {
        //     const blockConfig = _TypeConfig.panel.layoutStyleV2('block');
        //     blockConfig.options.push(
        //         {
        //             display: 'Minimum Height',
        //             fullWidth: true,
        //             group: blockConfig.group,
        //             name: 'minHeight',
        //             options: _TypeConfig.dropdown.measurement(true),
        //             type: 'measurement-slider'
        //         }
        //     );
        //     return blockConfig;
        // }
    },
    visibility: {
        hasAtLeast2Columns: (config) => config.Block && (config.Block.columnCount == '2' || config.Block.columnCount == '3' || config.Block.columnCount == '4' || config.Block.columnCount == '5' || config.Block.columnCount == '6'),
        hasAtLeast3Columns: (config) => config.Block && (config.Block.columnCount == '3' || config.Block.columnCount == '4' || config.Block.columnCount == '5' || config.Block.columnCount == '6'),
        hasAtLeast4Columns: (config) => config.Block && (config.Block.columnCount == '4' || config.Block.columnCount == '5' || config.Block.columnCount == '6'),
        hasAtLeast5Columns: (config) => config.Block && (config.Block.columnCount == '5' || config.Block.columnCount == '6'),
        hasAtLeast6Columns: (config) => config.Block && config.Block.columnCount == '6'
    }
};

// #endregion V2

module.exports = {
    V1: {
        Component: Columns,
        TypeConfig
    },
    V2: {
        Component: ColumnsV2,
        TypeConfig: TypeConfigV2
    }
};